import { ReactNode, useCallback } from 'react'

import { Menu } from 'govwell-ui'
import { observer } from 'mobx-react-lite'
import { GetOrCreateViewsMutation } from 'types/graphql'

import CreateViewModal from 'src/components/TableViews/CreateViewModal'
import DeleteViewModal from 'src/components/TableViews/DeleteViewModal'
import RenameViewModal from 'src/components/TableViews/RenameViewModal'
import { TableViewMode } from 'src/fetch/views'
import useDisclosure from 'src/hooks/use-disclosure'
import { TableView } from 'src/models/TableViews/TableView'
import { TableViewManager } from 'src/models/TableViews/TableViewManager'

type Props = {
  children: ReactNode
  generateDefaultViews: () => Promise<GetOrCreateViewsMutation>
  mode: TableViewMode
  tableViewManager: TableViewManager
  view: TableView
}
const TableViewTab = ({ children, generateDefaultViews, mode, tableViewManager, view }: Props) => {
  const { isOpen: isMenuOpen, open: onOpenMenu, close: onCloseMenu } = useDisclosure()

  const handleRightClick = useCallback(
    (e: React.MouseEvent) => {
      if (mode === TableViewMode.View) {
        return
      }
      e.preventDefault()
      onOpenMenu()
    },
    [mode, onOpenMenu]
  )

  const renameModalState = useDisclosure()
  const duplicateModalState = useDisclosure()
  const deleteModalState = useDisclosure()

  return (
    <>
      <Menu isOpen={isMenuOpen} onClose={onCloseMenu} onOpen={onOpenMenu}>
        <Menu.Trigger isDisabled onContextMenu={handleRightClick}>
          {children}
        </Menu.Trigger>
        <Menu.Content sideOffset={0}>
          <Menu.Item icon="FaPen" onClick={renameModalState.open}>
            Rename
          </Menu.Item>
          <Menu.Item icon="FaCopy" onClick={duplicateModalState.open}>
            Duplicate
          </Menu.Item>
          <Menu.Item icon="FaTrash" onClick={deleteModalState.open}>
            Delete
          </Menu.Item>
        </Menu.Content>
      </Menu>
      <RenameViewModal modalState={renameModalState} view={view} />
      <CreateViewModal
        modalState={duplicateModalState}
        duplicateFromView={view}
        tableViewManager={tableViewManager}
      />
      <DeleteViewModal
        generateDefaultViews={generateDefaultViews}
        modalState={deleteModalState}
        tableViewManager={tableViewManager}
        view={view}
      />
    </>
  )
}

export default observer(TableViewTab)
